const host = window.location.hostname;

const CLIENTID_BY_ENV = {
    "dev.aichat.arc.travel": "0oa1sjy9hapf9f8GB358",
    "qa.aichat.arc.travel": "0oa1ss05mgyi725kA358",
    "uat.aichat.arc.travel": "0oa1ss0o4mzlApBDa358",
    "aichat.arc.travel": "0oa1ss0nub8YdXwWC358"
}

const CLIENTID_BASE = CLIENTID_BY_ENV[host] || "0oa1sjy9hapf9f8GB358";


const oktaConfig = {
    
    //clientId: "0oa1sjy9hapf9f8GB358",
    clientId: CLIENTID_BASE,
    issuer: "https://myarc.okta.com/oauth2/default",
    redirectUri: window.location.origin + "/login/callback",
    scopes: ["openid", "profile", "email"], // ✅ Required
    pkce: true, // ✅ Required
    tokenManager: {
        storage: 'localStorage'  
    }
    
    
};

  
export default oktaConfig;